import {useContext, useEffect} from 'react';
import {Navigate} from 'react-router-dom';

import AuthContext from '../../store/auth-context';
import PatientContext from "../../store/patient-context";

// -----------------------------------------------------------------------------

const LogoutPage = (props) => {
  const authCtx = useContext(AuthContext);
  const patientCtx = useContext(PatientContext);

  useEffect(() => {
    authCtx.logout();  // Wrapped inside a useEffect to avoid the "Cannot update a component while rendering a different component" warning.
    patientCtx.clear();
  }, [authCtx, patientCtx]);

  return <Navigate to="/auth" />
}

// -----------------------------------------------------------------------------
export default LogoutPage;
